<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    //  debugger
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      // vnodes.push(<svg-icon icon-class={icon}/>)
      // console.log(icon)
      vnodes.push(<i class={icon}></i>)
    }

    if (title) {
      vnodes.push(<span style='margin-left:15px;' slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
<style lang="scss">
  .sidebar-item{
    display: flex;
    align-items: center;
    justify-content: center
  }
</style>
